
class EducationalDegreeModel {
    id: number;
    title: string;
    isActive: boolean;

    constructor(
        id: number,
        title: string,
        isActive: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.isActive = isActive;
    }

    public static fromJson(json: any): EducationalDegreeModel {
        return new EducationalDegreeModel(
            json["id"],
            json["title"],
            json["isActive"],
        );
    }
}


export interface EducationalDegreeGetPayloadFilterModel {
    id?: number;
    title?: string;
    isActive?: number;
}

export interface EducationalDegreeGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: EducationalDegreeGetPayloadFilterModel;
}


export interface EducationalDegreePayloadModel {
    id: number;
    title: string;
    isActive: boolean;

}
export default EducationalDegreeModel;
